import { ChakraBox, ChakraText } from '@equip.health/ui';

interface StatusLabelProps {
  color: string;
  status: string;
  textColor: string;
}

const StatusLabel = ({ color, status, textColor }: StatusLabelProps) =>
  !status ? null : (
    <ChakraBox
      background={color}
      borderRadius="8px"
      fontSize="10px"
      fontWeight="700"
      padding="4px 8px"
      width="fit-content"
    >
      <ChakraText as="h6" color={textColor} fontSize="10px">
        {status}
      </ChakraText>
    </ChakraBox>
  );

export default StatusLabel;
